import React from 'react';
import { Link } from 'react-router-dom';

const serviceLinks = [
  { path: '/web-application', label: 'Web Application' },
  { path: '/mobile-application', label: 'Mobile Application' },
  { path: '/digital-marketing', label: 'Digital Marketing' },
  { path: '/devops', label: 'DevOps' },
  { path: '/software-training', label: 'Software Training' },
  { path: '/software-consulting', label: 'Software Consulting' },
];

const contactInfoItems = [
  { iconClass: 'icon-location-filled', label: 'Address', lines: ['44 Abelard Ave, Brampton, ON L6Y2K8, Canada.'] },
  { iconClass: 'icon-phone-auricular', label: 'Get In Touch', lines: ['+1(647)-687-4226'], hrefs: ['tel:+16476874226'] },
  { iconClass: 'icon-email2', label: 'Quick Email us', lines: ['magizhinitech@gmail.com'], hrefs: ['mailto:magizhinitech@gmail.com'] },
];

export default function ServiceLayout({ title, banner, current, children }) {
  return (
    <>
      {/* Page Header */}
      <section className="relative overflow-hidden min-h-[280px] md:min-h-[360px] flex items-center bg-brand-dark">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-40"
          style={{ backgroundImage: `url(${banner})` }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-brand-dark/30 to-brand/5"></div>
        <div className="container relative z-10 py-20">
          <div className="text-center">
            <h2 className="text-4xl md:text-5xl font-bold font-heading text-white mb-4">{title}</h2>
            <ul className="flex justify-center items-center gap-3 text-white/70 text-sm list-none p-0 m-0">
              <li><Link className="hover:text-brand transition-colors" to="/">Home</Link></li>
              <li><span className="text-white/40">/</span></li>
              <li><Link className="hover:text-brand transition-colors" to="/services">Services</Link></li>
              <li><span className="text-white/40">/</span></li>
              <li className="text-brand">{title}</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Main detail section */}
      <section className="py-16 bg-white">
        <div className="container">
          <div className="row">
            {/* Sidebar */}
            <div className="col-xl-4">
              <div className="space-y-6 mb-10 xl:mb-0">
                {/* Services list */}
                <div className="bg-white rounded-xl shadow-md overflow-hidden wow animated fadeInUp" data-wow-delay="0.1s">
                  <div className="bg-brand-dark px-6 py-4 flex items-center gap-3">
                    <img src="/assets/images/shapes/sidebar-title-shape.png" alt="#" className="w-6 h-6 opacity-80" />
                    <h2 className="text-white font-bold font-heading text-lg">Services List</h2>
                  </div>
                  <ul className="divide-y divide-gray-100 list-none p-0 m-0">
                    {serviceLinks.map(({ path, label }) => (
                      <li key={path}>
                        <Link
                          to={path}
                          className={`flex justify-between items-center px-6 py-3 text-sm font-medium transition-colors ${path === current
                              ? 'bg-brand text-white'
                              : 'text-brand-dark/80 hover:bg-brand/5 hover:text-brand'
                            }`}
                        >
                          {label}
                          <span className="icon-right-arrow2 text-xs"></span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Query card */}
                <div className="bg-white rounded-xl shadow-md overflow-hidden wow animated fadeInUp" data-wow-delay="0.3s">
                  <div className="bg-brand-dark px-6 py-4 flex items-center gap-3">
                    <img src="/assets/images/shapes/sidebar-title-shape.png" alt="#" className="w-6 h-6 opacity-80" />
                    <h2 className="text-white font-bold font-heading text-lg">Have Any Query?</h2>
                  </div>
                  <div
                    className="relative"
                    style={{ backgroundImage: 'url(/assets/images/backgrounds/sidebar-gradient-bg1.png)', backgroundSize: 'cover' }}
                  >
                    <img
                      src="/assets/images/resources/img5.png"
                      alt="#"
                      className="w-full h-44 object-cover opacity-50"
                    />
                    <div className="absolute inset-0 bg-brand-dark/60 flex flex-col justify-center items-center text-center p-6">
                      <p className="text-white text-sm font-semibold mb-4">Here's how you can get in touch:</p>
                      <a
                        href="tel:+16476874226"
                        className="flex items-center gap-2 bg-brand text-white px-5 py-2 rounded-full text-sm hover:bg-opacity-80 transition-colors"
                      >
                        <span className="icon-phone-auricular"></span>
                        +1(647)-687-4226
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Main content */}
            <div className="col-xl-8">
              <div className="xl:pl-8">
                {children}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Google Map */}
      <section className="w-full">
        <iframe
          src="https://maps.google.com/maps?q=44+Abelard+Ave,+Brampton,+ON+L6Y2K8,+Canada&t=&z=15&ie=UTF8&iwloc=&output=embed"
          className="w-full h-72 md:h-96 border-0 block"
          allowFullScreen=""
          title="Office map"
        ></iframe>
      </section>

      {/* Contact Info */}
      <section className="py-16 bg-gray-50">
        <div className="container">
          <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden p-8 md:p-12">
            <div
              className="absolute inset-0 opacity-5"
              style={{ backgroundImage: 'url(/assets/images/shapes/contact-info-v1-bg0.png)', backgroundSize: 'cover' }}
            ></div>
            <div className="row relative z-10">
              {contactInfoItems.map(({ iconClass, label, lines, hrefs }, i) => (
                <div className="col-xl-4 col-lg-4" key={i}>
                  <div className="flex items-start gap-4 mb-8 xl:mb-0">
                    <div className="flex-shrink-0 w-14 h-14 rounded-full bg-brand flex items-center justify-center text-white text-xl">
                      <span className={iconClass}></span>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500 uppercase tracking-widest font-medium mb-1">{label}</p>
                      {lines.map((line, j) =>
                        hrefs ? (
                          <h3 key={j} className="text-brand-dark font-semibold text-sm leading-relaxed">
                            <a href={hrefs[j]} className="hover:text-brand transition-colors">{line}</a>
                          </h3>
                        ) : (
                          <h3 key={j} className="text-brand-dark font-semibold text-sm leading-relaxed">{line}</h3>
                        )
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
